export function countValues<T extends Record<string, any>>(source: T): number {
  let count = 0;

  for (const value of Object.values(source)) {
    if (value === null || value === undefined) {
      continue;
    }

    if (Array.isArray(value)) {
      count += value.length;
    } else if (typeof value === 'object' && value !== null) {
      count += countValues(value);
    } else {
      count += 1;
    }
  }

  return count;
}
